import { render } from "./wheelDemo.vue?vue&type=template&id=915af74c&scoped=true"
import script from "./wheelDemo.vue?vue&type=script&lang=js"
export * from "./wheelDemo.vue?vue&type=script&lang=js"

import "../assets/css/game_wheel.css?vue&type=style&index=0&id=915af74c&scoped=true&lang=css"
import "./wheelDemo.vue?vue&type=style&index=1&id=915af74c&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915af74c"]])

export default __exports__